import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {EmptyLoadingStateHandler} from "../../../../../core/handlers/empty-loading-state-handler";


export class CompetitionBracketsPageHandlers extends HandlerList {
  static injectables = [EmptyLoadingStateHandler];

  constructor(emptyStateHandler: EmptyLoadingStateHandler) {
    super();

    [emptyStateHandler].forEach(handler => this.add(handler));
  }
}
